export function setMarketingInfo(value: any) {
  sessionStorage.setItem('@tim:marketingInfo', JSON.stringify(value));
}

export const getMarketingInfo = () =>
  sessionStorage.getItem('@tim:marketingInfo');

export const removeMarketingInfo = () =>
  sessionStorage.removeItem('@tim:marketingInfo');

export function setUuidStorageSession(value: string) {
  sessionStorage.setItem('@ecommerce:uuid', JSON.stringify(value));
}

export const getUuidStorageSession = () =>
  sessionStorage.getItem('@ecommerce:uuid');

export const removeUuidStorageSession = () =>
  sessionStorage.removeItem('@ecommerce:uuid');
